module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticStyle: {
      "font-size": "10px"
    }
  }, [_vm._v("auth: " + _vm._s(JSON.stringify({
    user: _vm.user,
    key: _vm.key
  }, null, 2)) + "\nrouter: " + _vm._s(JSON.stringify({
    path: _vm.path,
    params: _vm.params
  }, null, 2)) + "\npublicConfig: " + _vm._s(JSON.stringify({
    config: _vm.config,
    error: _vm.error,
    loading: _vm.loading
  }, null, 2)))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-76575fa4"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/tmp-debug/TmpDebug.vue
// module id = 2063
// module chunks = 1